module.exports = "/_next/static/images/trop-27db66e2b6b24712baec30186f9428d1.svg";